import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Container = styled(Flex).attrs({
  column: true,
  as: 'form',
  fillSpace: true,
  spacing: 20,
})`
  position: relative;
`;

export const Header = styled(Flex).attrs({
  flex: '0 0 55px',
  align: 'center',
  justify: 'space-between',
})`
  width: 100%;
  margin-top: 15px;
  padding: 0 30px;
  border-bottom: 1px solid rgba(40, 45, 48, 0.1);
  background-color: #f9f9f9;
  position: sticky;
  top: 0;
  z-index: 11;

  &:first-child {
    margin-top: 0;
  }
`;

export const Content = styled(Flex).attrs({
  spacing: 30,
  fillSpace: true,
})`
  padding: 0 30px;
  margin: auto;
  margin-top: 55px;
  width: 100%;
  min-height: 400px;
  margin: auto;
  padding-bottom: 30px;

  textarea {
    margin: 0 !important;
  }
`;
